(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const init = (root = document) => {
    root.querySelectorAll('[data-jf-menu]').forEach(menu => {
      if (menu.dataset.jfReady) return;
      menu.dataset.jfReady = 'true';
      menu.addEventListener('keydown', event => {
        if (event.key === 'Escape' && menu.open) {
          menu.open = false;
          menu.querySelector('summary').focus();
        }
      });
      menu.addEventListener('click', event => {
        if (event.target.closest('a')) menu.open = false;
      });
      document.addEventListener('click', event => {
        if (menu.open && !menu.contains(event.target)) menu.open = false;
      });
    });
    root.querySelectorAll('[data-jf-gallery]').forEach(gallery => {
      if (gallery.dataset.jfReady) return;
      gallery.dataset.jfReady = 'true';
      const buttons = [...gallery.querySelectorAll('[data-jf-filter]')];
      const photos = [...gallery.querySelectorAll('[data-jf-category]')];
      const status = gallery.querySelector('[data-jf-gallery-status]');
      const applyFilter = category => {
        const current = buttons.some(button => button.dataset.jfFilter === category) ? category : 'all';
        buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.jfFilter === current)));
        let count = 0;
        photos.forEach(photo => {
          photo.hidden = current !== 'all' && photo.dataset.jfCategory !== current;
          if (!photo.hidden) count++;
        });
        if (status) status.textContent = status.dataset.message.replace('{count}', String(count));
      };
      gallery.querySelector('[data-jf-filters]').hidden = false;
      buttons.forEach(button => button.addEventListener('click', () => {
        applyFilter(button.dataset.jfFilter);
        history.replaceState(null, '', '#' + button.dataset.jfFilter);
      }));
      applyFilter(location.hash.slice(1));
      window.addEventListener('hashchange', () => applyFilter(location.hash.slice(1)));
      const dialog = gallery.querySelector('[data-jf-lightbox]');
      const image = dialog.querySelector('[data-jf-lightbox-image]');
      const caption = dialog.querySelector('[data-jf-lightbox-caption]');
      if (typeof dialog.showModal === 'function') {
        gallery.querySelectorAll('[data-jf-photo]').forEach(link => link.addEventListener('click', event => {
          event.preventDefault();
          image.src = link.href;
          image.alt = link.dataset.jfCaption;
          caption.textContent = link.dataset.jfCaption;
          dialog.showModal();
        }));
        dialog.querySelector('[data-jf-close]').addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', event => {
          const rect = dialog.getBoundingClientRect();
          if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) dialog.close();
        });
        dialog.addEventListener('close', () => image.removeAttribute('src'));
      }
    });
    const quickbar = document.querySelector('[data-jf-quickbar]');
    if (quickbar && !quickbar.dataset.jfReady && 'IntersectionObserver' in window) {
      quickbar.dataset.jfReady = 'true';
      const form = document.querySelector('main form');
      if (form) new IntersectionObserver(entries => { quickbar.hidden = entries[0].isIntersecting; }, {threshold:0}).observe(form);
    }
    if (!reduceMotion && 'IntersectionObserver' in window && !(window.Shopify && Shopify.designMode)) {
      const observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        const el = entry.target;
        observer.unobserve(el);
        if (typeof el.animate === 'function') el.animate([{transform:'translateY(16px)',opacity:0.65},{transform:'translateY(0)',opacity:1}],{duration:520,easing:'cubic-bezier(.2,.6,.2,1)'});
      }), {threshold:0.08});
      root.querySelectorAll('.jf-reveal').forEach(el => {
        if (el.dataset.jfRevealed) return;
        el.dataset.jfRevealed = 'true';
        if (el.getBoundingClientRect().top > window.innerHeight) observer.observe(el);
      });
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
